module.exports = __webpack_public_path__ + "banquet/components/images/banquet_white_logo_2x.a9680c63908edcaf0b4ba36bad24fcb4.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/banquet_white_logo_2x.png
// module id = 1697
// module chunks = 1